/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why plot cumulative skew?`)
};

const es_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué graficar el sesgo acumulado?`)
};

const de_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum den kumulativen Skew plotten?`)
};

const nl_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom cumulatieve skew plotten?`)
};

const fr_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi tracer le biais cumulé ?`)
};

const it_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché tracciare lo skew cumulativo?`)
};

const pt_br2_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que plotar o skew acumulado?`)
};

const pt_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque representar a assimetria cumulativa?`)
};

const ja_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`累積スキューをプロットする理由は？`)
};

const zh_gcskew_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要绘制累积偏斜？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_faq_q2", locale)
	if (locale === "en") return en_gcskew_faq_q2(inputs)
	if (locale === "es") return es_gcskew_faq_q2(inputs)
	if (locale === "de") return de_gcskew_faq_q2(inputs)
	if (locale === "nl") return nl_gcskew_faq_q2(inputs)
	if (locale === "fr") return fr_gcskew_faq_q2(inputs)
	if (locale === "it") return it_gcskew_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_faq_q2(inputs)
	if (locale === "pt") return pt_gcskew_faq_q2(inputs)
	if (locale === "ja") return ja_gcskew_faq_q2(inputs)
	return zh_gcskew_faq_q2(inputs)
};